import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { setEndDate, getEndDate } from '../../store/slices/domainOrchestratorPricingCommittee.slice';

export const EndDateFilter = () => {
  const dispatch = useDispatch();
  const endDate = useSelector(getEndDate);

  useEffect(() => {
    if (!endDate) {
      const today = new Date().toISOString().slice(0, 10);
      dispatch(setEndDate(today));
    }
  }, [endDate, dispatch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setEndDate(e.target.value));
  };

  return (
    <Form.Control
      type="date"
      value={endDate}
      onChange={handleChange}
      style={{ fontSize: '14px' }}
    />
  );
};
